export const extractPermissionHeaders = (response) => ({
  /*
  TODO: it's a workaround for Mozilla firefox,
  because firefox returns the undefined value for empty headers.
  */
  scope: response.headers['x-scope-header'] || '',
  zone: response.headers['x-zone-header'] || '',
});
